import React from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/shared/buttons/Button';
import ContainerHeader from '../../components/shared/container/ContainerHeader';
import { createVisitAction } from '../../redux/actions/visitsActions';
import ContainerTitle from '../shared/container/ContainerTitle';

const VisitsHeader = ({ readOnly }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const vin = useSelector((state) => state.vehicle?.vehicle?.vin);

  const handleAddVisitButtonClick = async () => {
    await dispatch(createVisitAction(vin, navigate));
  };

  return (
    <ContainerHeader>
      <ContainerTitle title={'Візити автомобіля'} />
      {!readOnly && (
        <Button variant={'primary'} onClick={handleAddVisitButtonClick}>
          <AiOutlinePlus />
          Додати
        </Button>
      )}
    </ContainerHeader>
  );
};

export default VisitsHeader;
